import api from "./axiosConfig";

export async function presignAttachmentUpload(fileName, contentType, fileSize) {
  const response = await api.post("/api/support-tickets/attachments/presign-upload", {
    fileName,
    contentType,
    fileSize
  });
  return response.data;
}

export async function uploadAttachmentToS3(uploadUrl, file) {
  const s3Response = await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type
    },
    body: file
  });

  if (!s3Response.ok) {
    throw new Error("Failed to upload attachment to S3");
  }
}

export async function createTicket(type, text, attachments = []) {
  const response = await api.post("/api/support-tickets", {
    type,
    text,
    attachments
  });
  return response.data;
}

export async function getUserTickets() {
  const response = await api.get("/api/support-tickets/my");
  return response.data;
}

export async function getTicket(ticketId) {
  const response = await api.get(`/api/support-tickets/${ticketId}`);
  return response.data;
}

export async function addTicketMessage(ticketId, text, attachments = []) {
  const response = await api.post(`/api/support-tickets/${ticketId}/messages`, {
    text,
    attachments
  });
  return response.data;
}
